// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Refresh = function Refresh(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.18 6.598c0 .14-.12.27-.26.27l-4.62.01c-.24 0-.36-.28-.19-.45l1.66-1.66c-.76-.65-1.71-1-2.74-1a4.31 4.31 0 103.62 6.65l.8.52.8.51c-.01.03-.03.05-.05.08-1.1 1.7-3.05 2.76-5.17 2.76a6.21 6.21 0 114-10.96l.1.08 1.68-1.68c.16-.06.35.05.35.25l.02 4.62z"
    }))
  );
};

export default Refresh;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Refresh.js
// module id = 1040
// module chunks = 0